// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Стратегія» (Strategy, ключ `pstrat`, група `analysis`). */
export const strategyManifest: IModuleManifest = {
  key: 'pstrat',
  group: 'analysis',
  slug: 'strategy',
  prefix: 'STR',
  name: { en: 'Strategy', uk: 'Стратегія' },
  entities: [
    { key: 'pstrat', slug: 'pstrat', name: { en: 'Strategic goals', uk: 'Стратегічні цілі' }, main: true },
    { key: 'pinit', slug: 'pinit', name: { en: 'Initiatives', uk: 'Ініціативи' }, main: false },
    { key: 'pkpi', slug: 'pkpi', name: { en: 'KPIs', uk: 'KPI' }, main: false },
    { key: 'swot_item', slug: 'swot-item', name: { en: 'SWOT items', uk: 'Елементи SWOT' }, main: false },
  ],
  loadState: () => import('./state/strategySlice').then((m) => m.strategySlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
